export default __webpack_public_path__ + "static/media/icon-payroll-inverted.f7d37bcb.svg";